import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { calculateWidths as calculateWidthsV2 } from '../utilV2';
import styles from './index.module.scss';
import { STATUS } from '../../../../dv2_temporary_solution/constants/status';
import useProgressbarData from '../../ProgressBar/useProgressbarData';

const BarSegment = ({ isActive, invertColors, thickBar, width }) => {
  const progressBarRef = useRef(null);

  useEffect(() => {
    if (progressBarRef.current) {
      progressBarRef.current.style.width = `${width}%`;
    }
  }, [width]);

  return (
    <div
      className={classnames(
        styles.placeholderBar,
        { [styles.isActive]: isActive },
        { [styles.invertColors]: invertColors }
      )}
    >
      <div
        ref={progressBarRef}
        className={classnames(
          styles.progressBar,
          { [styles.isActive]: isActive },
          { [styles.invertColors]: invertColors },
          { [styles.thick]: thickBar }
        )}
      >
        {isActive && (
          <span
            className={classnames(styles.circle, {
              [styles.thickBarCircle]: thickBar,
            })}
          />
        )}
      </div>
    </div>
  );
};

const MiniProgressBar = (props) => {
  const {
    widthsList,
    thickBar,
    invertColors,
  } = props;

  const progressBarData = useProgressbarData();

  const calculatedWidthList = calculateWidthsV2(progressBarData);
  const bars = widthsList || calculatedWidthList;

  return (
    <div
      data-cy="mini-progress-bar-wrapper"
      className={classnames(styles.progressBarWrapper, {
        [styles.thick]: thickBar,
      })}
    >
      <div data-cy="mini-progress-bar-placeholder-wrapper" className={styles.placeholderWrapper}>
        {bars.map((bar, index) => (
          <BarSegment
            data-cy={`barsegment-${index}`}
            key={index}
            isActive={bar.active}
            thickBar={thickBar}
            width={bar.width}
            invertColors={invertColors}
          />
        ))}
      </div>
    </div>
  );
};

MiniProgressBar.defaultProps = {
  invertColors: false,
  thickBar: false,
  currentStatus: STATUS.SIGNUP_COMPLETED,
};

export default MiniProgressBar;
